import React from "react";
import {Box, Skeleton, Stack, Typography} from "@mui/material";
import TourHeaderButtonsSkeleton
  from "@/components/product-detail-page/tour-header/tour-header-buttons/tour-header-buttons.skeletons";
import KeyTourInfoSkeletonColumn
  from "@/components/product-detail-page/tour-header/key-tour-info/column/key-tour-info.skeleton.column";
import KeyTourInfoSkeletonRow
  from "@/components/product-detail-page/tour-header/key-tour-info/row/key-tour-info.skeleton.row";
import {useTranslations} from "next-intl";

const TourHeaderSkeleton = ({
  tourTitle
}: {
  tourTitle?: string;
}) => {
  const t = useTranslations("PDP");

  const details: {
    id: string,
    label?: string,
    showInfoIcon?: boolean
  }[] = [
    {
      id: "days",
      label: t("DAYS")
    },
    {
      id: "group-size",
      label: t("GROUP SIZE")
    },
    {
      id: "price",
      label: t("FROM PER PERSON")
    },
    {
      id: "reviews",
      label: t("REVIEWS")
    },
    {
      id: "activity-level",
      label: t("ACTIVITY LEVEL"),
      showInfoIcon: true
    },
    {
      id: "meals",
      label: t("MEALS")
    },
    {
      id: "travel-style",
      label: t("TRAVEL STYLE"),
      showInfoIcon: true
    }
  ];

  return (
    <Stack
      sx={{
        gap: "2.4rem"
      }}
      data-testid="product-detail-page-skeleton_header"
    >
      <Stack direction="row" justifyContent="space-between" gap="1.2rem" alignItems="center">
        <Stack>
          {/* Chips */}
          <Skeleton
            variant="rounded"
            sx={{
              borderRadius: "0.8rem",
              height: "3.2rem",
              width: "8rem",
              marginBottom: "1.2rem"
            }}
          />
          {/* H1 */}
          <Typography
            variant="h1"
            data-testid="product-detail-page-skeleton_title"
          >
            {tourTitle || <Skeleton width="20rem"/>}
          </Typography>
        </Stack>
        <Box sx={{display: {xs: "none", lg: "inline"}}}>
          <TourHeaderButtonsSkeleton/>
        </Box>
      </Stack>
      <Box sx={{
        display: {xs: "inline", lg: "none"},
        marginRight: "4rem"
      }}>
        <KeyTourInfoSkeletonColumn
          labelColor="secondary"
          testId="pdp_key-tour-info-skeleton"
          details={details}
        />
      </Box>
      <Box sx={{display: {xs: "none", lg: "inline"}}}>
        <KeyTourInfoSkeletonRow
          labelColor="secondary"
          testId="pdp_key-tour-info-skeleton"
          details={details}
        />
      </Box>
      <Box sx={{display: {xs: "inline", lg: "none"}}}>
        <TourHeaderButtonsSkeleton/>
      </Box>
    </Stack>
  );
};

export default TourHeaderSkeleton;